const Time = (props) => {

 return(
     <span>{props.time}</span>
 )

}

export default Time
